import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";

interface AdjustTransactionModalButtonsProps {
  loading: boolean;
  readOnly?: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const AdjustTransactionModalButtons: React.FC<AdjustTransactionModalButtonsProps> = ({
  loading, readOnly, onCancel, onSave,
}) => {
  const { t } = useTranslation();
  const base = 'reconciliation.managerStatement.detail.pageTexts.detailsTab.transactions.adjustModal';

  if (readOnly) {
    return (
      <div className="d-flex gap-3">
        <Button
          className="btn btn-outline-secondary"
          text={t(`${base}.closeBtn`)}
          onClick={onCancel}
        />
      </div>
    );
  }

  return (
    <div className="d-flex gap-3">
      <Button
        className="btn btn-primary"
        text={t(`${base}.saveBtn`)}
        loading={loading}
        onClick={onSave}
      />
      <Button
        className="btn btn-outline-secondary"
        text={t(`${base}.cancelBtn`)}
        onClick={onCancel}
      />
    </div>
  );
};

export default AdjustTransactionModalButtons;
